<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
      <!--<span style="margin-right:10px;" slot="orderList">我的订单</span>-->
    </nav-bread>
    <div class="container">
      <!--pc端-->
      <el-container>
        <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        <el-container style="margin:20px 0 0 20px;">
          <el-header>我的报告 > 高诊无忧
            <el-input
              v-model="keyword"
              placeholder="请输入搜索内容"
              style="float: right;width:200px;"
              @input="inputKey"
              @keyup.enter.native="search">
              <i
                class="el-icon-search"
                slot="suffix"
                @click="search">
              </i>
            </el-input>
          </el-header>
          <div class="a" @click="back"> << 返回</div>
          <el-main v-loading="loading">
            <div class="order-item" v-for="(item,index) in reportList">
              <div class="order-item-title">
                采样器编号：{{item.snCode}}
                <span style="float: right;">{{item.addTime}}</span>
              </div>
              <el-table
                :data="item.itemReportList"
                style="width: 100%">
                <!--<el-table-column-->
                  <!--prop="snCode"-->
                  <!--label="采样器编号"-->
                  <!--width="150">-->
                <!--</el-table-column>-->
                <el-table-column
                  prop="itemName"
                  label="商品名称"
                  width="350">
                </el-table-column>
                <el-table-column
                  prop="realName"
                  label="姓名"
                  width="350">
                </el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  width="200">
                  <template slot-scope="scope">
                    <span class="state" v-if="item.sampleStatus==0">待收样</span>
                    <span class="state" v-if="item.sampleStatus==1">待检测</span>
                    <span class="state" v-if="item.sampleStatus==2">检测完成</span>
                    <el-button
                      @click.native.prevent="downloadReport(item.reportUrl)"
                      type="primary"
                      size="small"
                      v-if="item.sampleStatus==2">
                      查看报告
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="limit"
              layout="prev, pager, next, jumper"
              :total="totalCount"
              v-if="reportList.length"
              style="text-align:center;margin-top: 20px;">
            </el-pagination>
            <div class="empty" v-if="reportList.length==0 && !loading">
              当前没有报告信息哦
            </div>
          </el-main>

        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
  import '@/assets/css/index.css'
  import NavLeft from '@/components/NavLeft.vue'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread.vue'
  import {getCookie} from "../../util/util";
  import '@/assets/css/index.css'
  import axios from "axios"

  export default {
    name: "my-medical-report",
    data(){
      return {
        p_activeIndex:"3",
        p_showSearch:true,
        p_loginModalFlag:false,
        limit:7,
        page:1,
        reportList:[],
        isChannel:true,
        loading:true,
        keyword:"",
        totalCount:0,
        totalPage: 0,
        currentPage: 1,
      }
    },
    components:{
      NavLeft,
      NavHeader,
      NavBread
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    mounted(){
      if (getCookie("_token")) {
        if(this.user.isChannel == 1 || this.user.isChannel == 2){
          this.isChannel = true
        }else{
          this.isChannel = false
        }
        this.getReportList()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
    },
    methods:{
      back(){
        this.$router.go(-1)
      },

      p_showLoginModal(){
        this.p_loginModalFlag = true
      },

      p_closeLoginModal(){
        this.p_loginModalFlag = false
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },

      handleCurrentChange(val) {
        this.page = val
        console.log(typeof val)
        this.getReportList(this.channel)
        console.log(`当前页: ${val}`);
      },

      downloadReport(reportUrl) {
        window.open(reportUrl)
        // this.$router.push({path: "/mine/orderDesc", query: {id: id}})
      },
      getReportList(){
        axios.get("/jys/sample/medicalList",{
          params:{
            limit:this.limit,
            page:this.page,
            itemName:this.keyword
          },
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((respose) => {
          let res = respose.data
          if(res.code == 0){
            this.loading = false
            let reportList = res.page.list
            this.totalPage = res.page.totalPage
            this.totalCount = res.page.totalCount
            reportList.map((item,index,arr)=>{
              return arr[index].itemReportList = [item]
            })
            this.reportList = reportList


          }else if(res.code == 401){
            this.loading = false
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
            this.$refs.navHeader.logout()
          }
        })
      },

      //搜索
      inputKey(){
        console.log(this.keyword)
        if(this.keyword.length == 0 ){
          this.page = 1
          this.getReportList()
        }
      },
      clearKey(){
        this.keyword = ""
        this.page = 1
        this.getReportList()
        console.log(this.keyword)
      },
      search(){
        this.page = 1
        this.getReportList()
      },
    }
  }
</script>

<style scoped>
  .a{
    height:40px;
    line-height: 60px;
    background-color: #fff;
    text-align: right;
    color: #00C5B0;
    padding:0 30px;
    text-decoration: underline;
  }

  .order-item {
    margin-bottom: 20px;
  }

  .order-item-title {
    /*width:100%;*/
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    background-color: #E9EEF3;
    text-align: left;
  }

  .state {
    display: block;
    color: #00C5B0;
    font-size: 16px;
    height:40px;
    line-height: 40px;
  }

  .empty {
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/MyMedicalReport.vue